"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContractListPaymentsResponseSchema = exports.AdminContractGetPaymentResponseSchema = exports.AdminContractPaymentIdPathParamsSchema = exports.AdminContractListPaymentsQueryParamsSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const schema_builder_1 = require("../../../shared/schema-builder");
const PaymentStatusSchema = zod_1.z.enum(['PENDING', 'PAID', 'FAILED', 'REFUNDED']);
const PaymentMethodSchema = zod_1.z.enum(['QR_CODE', 'PAYPAL']);
const PaymentSchema = zod_1.z.object({
    status: PaymentStatusSchema,
    method: PaymentMethodSchema,
    id: zod_1.z.string().uuid(),
    orderId: zod_1.z.string(),
    transactionId: zod_1.z.string(),
    paypalOrderId: zod_1.z.string().nullable(),
    paypalCaptureId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    paymentAt: zod_1.z.coerce.date().nullable(),
    amount: zod_1.z.number(),
    imageUrl: zod_1.z.string().nullable(),
});
exports.AdminContractListPaymentsQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema.extend({
    status: PaymentMethodSchema.optional(),
    sortBy: zod_1.z.string().default('createdAt|desc'),
});
exports.AdminContractPaymentIdPathParamsSchema = zod_1.z.object({ paymentId: zod_1.z.string() });
const AdminContractPaymentSchema = new schema_builder_1.SchemaBuilder(PaymentSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .replaceDateField('paymentAt', zod_1.z.string().nullable())
    .extend({
    orderNo: shared_1.NonNegativeIntSchema,
    customerName: zod_1.z.string(),
}).build();
exports.AdminContractGetPaymentResponseSchema = zod_1.z.object({ payment: AdminContractPaymentSchema });
exports.AdminContractListPaymentsResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ payments: AdminContractPaymentSchema.array() });
